import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BRAND } from '../data/constants';
import { useApp } from '../data/ColisContext';

export default function Navbar() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user, logout } = useApp();
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = typeof window !== 'undefined'
    ? window.matchMedia && window.matchMedia('(max-width: 640px)').matches
    : false;

  const isActive = (path) => location.pathname === path;

  const navBtnStyle = (path) => ({
    padding:      isMobile ? '8px 12px' : '8px 16px',
    borderRadius: 10,
    border:       'none',
    cursor:       'pointer',
    fontWeight:   600,
    fontSize:     isMobile ? 12 : 13,
    fontFamily:   'inherit',
    background:   isActive(path) ? BRAND.gradient : '#EEF2FF',
    color:        isActive(path) ? 'white'        : BRAND.primary,
    transition:   'all 0.2s',
    display:      'flex',
    alignItems:   'center',
    gap:          6,
  });

  useEffect(() => {
    setOpen(false);
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav style={{
      background:   'white',
      borderBottom: '1px solid #f0f0f0',
      padding:      isMobile ? '0 14px' : '0 24px',
      height:       64,
      display:      'flex',
      alignItems:   'center',
      justifyContent: 'space-between',
      position:     'sticky',
      top:          0,
      zIndex:       100,
      boxShadow:    '0 1px 12px rgba(0,0,0,0.06)',
    }}>
      {/* Logo */}
      <button
        onClick={() => navigate('/')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}
      >
        <span style={{ fontSize: 28 }}>📦</span>
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#1e293b', letterSpacing: -0.5, lineHeight: 1.2 }}>
            Zaki<span style={{ color: BRAND.primary }}>Express</span>
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500 }}>Livraison · Dakar</div>
        </div>
      </button>

      {/* Actions */}
      {isMobile ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => setMobileOpen(x => !x)}
            style={{
              padding: '10px 12px',
              borderRadius: 12,
              border: 'none',
              cursor: 'pointer',
              fontWeight: 900,
              fontSize: 16,
              fontFamily: 'inherit',
              background: mobileOpen ? BRAND.gradient : '#EEF2FF',
              color: mobileOpen ? 'white' : BRAND.primary,
              lineHeight: 1,
            }}
            aria-label="Menu"
          >
            ☰
          </button>

          {mobileOpen && (
            <div style={{ position: 'fixed', inset: 0, zIndex: 300 }}>
              <div
                onClick={() => setMobileOpen(false)}
                style={{ position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.35)' }}
              />

              <div style={{
                position: 'absolute',
                top: 10,
                right: 10,
                left: 10,
                background: 'white',
                borderRadius: 18,
                border: '1px solid #e2e8f0',
                boxShadow: '0 18px 60px rgba(0,0,0,0.22)',
                padding: 12,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 6px 10px' }}>
                  <div style={{ fontWeight: 900, color: '#0f172a' }}>Menu</div>
                  <button
                    onClick={() => setMobileOpen(false)}
                    style={{ background: '#F1F5F9', border: 'none', borderRadius: 12, padding: '8px 10px', cursor: 'pointer', fontWeight: 900 }}
                    aria-label="Fermer"
                  >
                    ✕
                  </button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {user && (
                    <button onClick={() => navigate('/dashboard')} style={navBtnStyle('/dashboard')}>
                      📊 Tableau de bord
                    </button>
                  )}
                  {user?.is_admin && (
                    <button onClick={() => navigate('/admin')} style={navBtnStyle('/admin')}>
                      🛠️ Admin
                    </button>
                  )}

                  <button onClick={() => navigate('/mes-colis')} style={navBtnStyle('/mes-colis')}>
                    📦 Mes colis
                  </button>
                  <button onClick={() => navigate('/suivi')} style={navBtnStyle('/suivi')}>
                    🔍 Suivi colis
                  </button>

                  {!user ? (
                    <>
                      <button onClick={() => navigate('/login')} style={navBtnStyle('/login')}>
                        🔐 Connexion
                      </button>
                      <button onClick={() => navigate('/register')} style={navBtnStyle('/register')}>
                        ✍️ Inscription
                      </button>
                    </>
                  ) : (
                    <>
                      <div style={{
                        background: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        borderRadius: 14,
                        padding: 10,
                      }}>
                        <div style={{ fontSize: 12, color: '#64748b', fontWeight: 900, marginBottom: 6 }}>Compte</div>
                        <div style={{ fontSize: 13, color: '#0f172a', fontWeight: 900, wordBreak: 'break-all' }}>{user?.email || '—'}</div>
                        <div style={{ fontSize: 12, color: '#475569', fontWeight: 800, marginTop: 4 }}>📞 {user?.phone || '—'}</div>
                      </div>

                      <button
                        onClick={() => navigate('/compte')}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          borderRadius: 12,
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: 900,
                          fontSize: 13,
                          fontFamily: 'inherit',
                          background: '#EEF2FF',
                          color: BRAND.primary,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 8,
                        }}
                      >
                        ✏️ Modifier mon compte
                      </button>

                      <button
                        onClick={() => {
                          logout();
                          navigate('/');
                        }}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          borderRadius: 12,
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: 900,
                          fontSize: 13,
                          fontFamily: 'inherit',
                          background: '#FEE2E2',
                          color: '#B91C1C',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 8,
                        }}
                      >
                        🚪 Déconnexion
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {user && (
            <button onClick={() => navigate('/dashboard')} style={navBtnStyle('/dashboard')}>
              📊 Tableau de bord
            </button>
          )}
          {user?.is_admin && (
            <button onClick={() => navigate('/admin')} style={navBtnStyle('/admin')}>
              🛠️ Admin
            </button>
          )}
          <button onClick={() => navigate('/mes-colis')} style={navBtnStyle('/mes-colis')}>
            📦 Mes colis
          </button>
          <button onClick={() => navigate('/suivi')} style={navBtnStyle('/suivi')}>
            🔍 Suivi colis
          </button>

          {!user ? (
            <>
              <button onClick={() => navigate('/login')} style={navBtnStyle('/login')}>
                🔐 Connexion
              </button>
              <button onClick={() => navigate('/register')} style={navBtnStyle('/register')}>
                ✍️ Inscription
              </button>
            </>
          ) : (
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setOpen(x => !x)}
                style={{
                  padding: '8px 16px',
                  borderRadius: 10,
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 800,
                  fontSize: 13,
                  fontFamily: 'inherit',
                  background: open ? BRAND.gradient : '#EEF2FF',
                  color: open ? 'white' : BRAND.primary,
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                👤 Mon compte
              </button>

              {open && (
                <div style={{
                  position: 'absolute',
                  top: 'calc(100% + 10px)',
                  right: 0,
                  width: 280,
                  background: 'white',
                  border: '1px solid #e2e8f0',
                  borderRadius: 14,
                  boxShadow: '0 12px 40px rgba(0,0,0,0.14)',
                  padding: 12,
                  zIndex: 200,
                }}>
                  <div style={{ padding: '8px 10px' }}>
                    <div style={{ fontSize: 12, color: '#64748b', fontWeight: 800, marginBottom: 6 }}>Informations</div>
                    <div style={{ fontSize: 13, color: '#0f172a', fontWeight: 800, wordBreak: 'break-all' }}>{user?.email || '—'}</div>
                    <div style={{ fontSize: 12, color: '#475569', fontWeight: 700, marginTop: 4 }}>📞 {user?.phone || '—'}</div>
                  </div>

                  <div style={{ height: 1, background: '#e2e8f0', margin: '10px 0' }} />

                  <button
                    onClick={() => {
                      setOpen(false);
                      navigate('/compte');
                    }}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      borderRadius: 12,
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: 900,
                      fontSize: 13,
                      fontFamily: 'inherit',
                      background: '#EEF2FF',
                      color: BRAND.primary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                      marginBottom: 10,
                    }}
                  >
                    ✏️ Modifier mon compte
                  </button>

                  <button
                    onClick={() => {
                      setOpen(false);
                      logout();
                      navigate('/');
                    }}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      borderRadius: 12,
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: 900,
                      fontSize: 13,
                      fontFamily: 'inherit',
                      background: '#FEE2E2',
                      color: '#B91C1C',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                    }}
                  >
                    🚪 Déconnexion
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </nav>
  );
}
